import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { PaginationInstance } from 'ngx-pagination';
import { ManuscriptList } from '../../../models/manuscript';
import { GetMsTitlePipe } from '../../../pipes/get-ms-title.pipe';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-mss-list',
  templateUrl: './mss-list.component.html',
  styleUrls: ['./mss-list.component.css']
})
export class MssListComponent implements OnInit {
    mssList: ManuscriptList;
    config: PaginationInstance = {
        id: 'mss-list-navigation',
        itemsPerPage: 10,
        currentPage: 1
    };
    thumbs$: Array<Observable<SafeUrl>> = [];
    loading: Array<boolean> = [];
    pageStart = 0;
    sortBy = 'title';

    constructor(
        private http: HttpClient,
        private domSanitizer: DomSanitizer,
        private manuscriptsService: ManuscriptsService,
        private getMsTitlePipe: GetMsTitlePipe) {
    }

    ngOnInit(): void {
        this.manuscriptsService.getManuscripts()
            .subscribe(
                response => {
                    this.mssList = response;
                    this.sortMssList('title');
                },
                err => console.error(err)
            );
    }

    loadThumbs() {
        if (this.mssList && this.mssList.length > 0) {
            this.pageStart = (this.config.currentPage - 1) * this.config.itemsPerPage;
            let pageEnd = this.pageStart + this.config.itemsPerPage;
            if (pageEnd > this.mssList.length) {
                pageEnd = this.mssList.length;
            }

            for (let i = this.pageStart; i < pageEnd; i++) {
                this.loading[i] = true;
                const msRow = this.mssList[i];
                const thumbUrl = environment.endpoints.images.thumbs + '/s/'
                    + (msRow.images_linked > 0 ? msRow.__imagesFolder :
                        (msRow.fkidms_types === 2 /* attested */ ? 'book' : 'hourglass')
                    )
                    + '.tif&CVT=jpeg';

                /* Load thumb images of the current page */
                this.thumbs$[i] = this.http.get(
                    thumbUrl,
                    {
                        headers: new HttpHeaders({
                            'Authorization': environment.apiKey,
                            'X-PhiBor-App': environment.phiborApp
                        }),
                        responseType: 'blob'
                    }
                )
                    .map(blob => {
                        this.loading[i] = false;
                        return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
                    });
            }
        }
    }

    changePage(pageNum: number) {
        this.config.currentPage = pageNum;
        this.loadThumbs();
    }

    sortMssList(sortBy: string) {
        this.sortBy = sortBy;
        this.mssList.sort((ms1, ms2) => {
            if (sortBy === 'date') {
                const ms1Date = ms1.__date.ah.from ? ms1.__date.ah.from : 9999;
                const ms2Date = ms2.__date.ah.from ? ms2.__date.ah.from : 9999;
                return ms1Date - ms2Date;
            } else {
                const ms1Title = this.getMsTitlePipe.transform(ms1, 'norm');
                const ms2Title = this.getMsTitlePipe.transform(ms2, 'norm');
                if (ms1Title > ms2Title) {
                    return 1;
                }
                if (ms1Title < ms2Title) {
                    return -1;
                }
                return 0;
            }
        });
        /* Go to first navigation page */
        this.changePage(1);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/mss-list/mss-list.component.ts